import '../../styles/form-group.scss';

import { CSSProperties, HTMLAttributes, ReactNode } from 'react';

export interface FormGroupProps extends HTMLAttributes<HTMLDivElement> {
  error?: boolean;
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
}

export default function FormGroup({ error, className, children, style }: FormGroupProps) {
  let formGroupClass = error ? 'govuk-form-group govuk-form-group--error' : 'govuk-form-group';
  if (className) {
    formGroupClass += ` ${className}`;
  }

  return (
    <div className={`${formGroupClass}`} style={style}>
      {children}
    </div>
  );
}
